import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import MuiButton from '@material-ui/core/Button';

import units from '../theme/units';

export type ButtonProps = import('@material-ui/core/Button').ButtonProps;

const useStyles = makeStyles(() => ({
  'iconSize-inherit': {
    '& > *:first-child': {
      fontSize: 'inherit',
    },
  },
  'iconSize-small': {
    '& > *:first-child': {
      fontSize: units.rem(0.5),
    },
  },
  'iconSize-large': {
    '& > *:first-child': {
      fontSize: units.rem(1.875),
    },
  },
}));

interface CustomProps {
  iconSize?: 'inherit' | 'small' | 'large' | 'default';
  rel?: string;
  target?: string;
  component?: string;
}

export type Props = CustomProps & ButtonProps;

const Button = React.forwardRef<HTMLButtonElement, Props>(
  ({ iconSize, classes, ...rest }, ref) => {
    const customClasses = useStyles();

    const newClasses = {
      ...classes,
      startIcon: cx(
        classes && classes.startIcon,
        customClasses[`iconSize-${iconSize}`],
      ),
      endIcon: cx(
        classes && classes.endIcon,
        customClasses[`iconSize-${iconSize}`],
      ),
    };

    return <MuiButton {...rest} ref={ref} classes={newClasses} />;
  },
);

export default Button;
